import { PublicKey } from "@solana/web3.js"

export function isValidSolanaAddress(address: string) {
  try {
    const pubkey = new PublicKey(address)
    return PublicKey.isOnCurve(pubkey.toBuffer())
  } catch (error) {
    return false
  }
}

export function isValidEthereumAddress(address: string) {
  return address.startsWith("0x") && address.length === 42
}
